var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticClass:"dd-crypto-page"},[_c('div',{staticClass:"dd-crypto-page__inner"},[_c('SubscriptionCryptoPaymentPanel')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }